<?xml version="1.0" encoding="UTF-8"?>
<!-- Generator: Adobe Illustrator 25.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.033 512.033" style="enable-background:new 0 0 512.033 512.033;" xml:space="preserve" width="512" height="512">
<g>
	<path d="M352.017,170.7H170.683v-16.491c0.009-49.815,40.399-90.19,90.214-90.181c32.799,0.006,63.01,17.816,78.895,46.511   c8.577,15.452,28.057,21.025,43.509,12.448s21.025-28.057,12.448-43.509l0,0C354.469,4.992,260.62-21.925,186.134,19.356   c-49.024,27.17-79.445,78.803-79.451,134.853v29.44c-39.236,20.023-63.952,60.334-64,104.384V394.7   c0.071,64.772,52.561,117.263,117.333,117.333h192c64.772-0.071,117.263-52.561,117.333-117.333V288.033   C469.28,223.261,416.789,170.771,352.017,170.7z M405.35,394.7c0,29.455-23.878,53.333-53.333,53.333h-192   c-29.455,0-53.333-23.878-53.333-53.333V288.033c0-29.455,23.878-53.333,53.333-53.333h192c29.455,0,53.333,23.878,53.333,53.333   V394.7z" fill="currentColor"/>
	<path d="M245.35,298.7h21.333c17.673,0,32,14.327,32,32l0,0c0,17.673-14.327,32-32,32H245.35c-17.673,0-32-14.327-32-32l0,0   C213.35,313.027,227.677,298.7,245.35,298.7z" fill="currentColor"/>
</g>















</svg>
